import { Component, OnInit, Inject, HostListener, Renderer2 } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

import { DeviceDetectorService } from 'ngx-device-detector';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';

import { PdfDocumentViewerDialogData, PdfDocumentInitParameters } from '../../models/pdf-document-viewer';

@Component({
    selector: 'app-pdf-document-viewer-dialog',
    templateUrl: './pdf-document-viewer-dialog.component.html',
    styleUrls: ['./pdf-document-viewer-dialog.component.scss']
})
export class PdfDocumentViewerDialogComponent implements OnInit {
    private _handleError: HandleError;
    private _logging = environment.logging;
    private _deviceSettings = environment.device;

    isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

    originalSize = false; // false
    fitToPage = true; // true
    autoResize = true; // true
    zoom = 'page-width';
    pdfHeight = '150px';
    isDeviceOsIos = false;

    pdfDocumentInitParameters: PdfDocumentInitParameters;

    pdfTotalPages = 0;
    pdfScrolledToBottom = false;

    showSpinner = true;
    showCloseButton = true;
    pdfLoadOK = false;
    pdfViewConfirmed = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: PdfDocumentViewerDialogData,
        private _errorHandler: ErrorHandler,
        private _deviceService: DeviceDetectorService,
        private renderer: Renderer2,
        public dialogRef: MatDialogRef<PdfDocumentViewerDialogComponent>
    ) {
        this._handleError = _errorHandler.createHandleError('PdfDocumentViewerDialogComponent');

        this.isDeviceOsIos = _deviceService.os.toUpperCase() === this._deviceSettings.iosOsName.toUpperCase();

        this.pdfScrolledToBottom = !data.requireScrollToEnd;
        this.pdfViewConfirmed = !data.requireScrollToEnd;

        this.pdfDocumentInitParameters = {
            url: data.pdfUrl
        };
    }

    ngOnInit() {
        this._getPdfHeight();
        this._adjustPdfZoom(); // Adjust zoom on initialization    //10/10/2025 Makes the PDF file to be really zoomed in.
    }

    pdfLoadError(error: any) {
        this.pdfLoadOK = false;
        this.showSpinner = false;
        this._handleError('pdfLoadError', error);
    }

    pdfLoadComplete(pdfData: any) {
        // console.log('pdfLoadComplete: ', pdfData);
        this.pdfTotalPages = pdfData.numPages;
        this.pdfLoadOK = true;
        this.showSpinner = false;
        this.listenScroll();

        setTimeout(() => {
            this._getPdfHeight();
        });
    }

    listenScroll(): void {

        const viewer = document.querySelector<HTMLDivElement>('.pdf-viewer');
        viewer.style.minHeight = '50vh';

        const container = document.querySelector<HTMLDivElement>('.ng2-pdf-viewer-container');

        if (!container) { return; }

        this.renderer.listen(container, 'scroll', (event: any) => {
            const element = event.target;
            const atBottom = element.scrollHeight - element.scrollTop <= (element.clientHeight + 10);

            console.log(element.scrollHeight - element.scrollTop);
            console.log(element.clientHeight + 10);

            if (atBottom) {
                console.log('Scrolled to the bottom of the PDF');
                this.pdfScrolledToBottom = true;
            }
        });
      }

    onCancelClick() {
        this.data.viewOK = false;
        this.dialogRef.close(this.data);
    }

    onCloseClick() {
        this.data.viewOK = this.pdfLoadOK && this.pdfViewConfirmed;
        this.dialogRef.close(this.data);
    }

    getShowCloseButton(): boolean {
        return this.data.requireScrollToEnd ? this.pdfLoadOK && this.pdfViewConfirmed : this.pdfLoadOK;
    }

    //   @HostListener('scroll', ['$event'])
    //   pdfScrolled(event) {
    //     if (Math.ceil(event.srcElement.scrollHeight - event.srcElement.scrollTop) === event.srcElement.clientHeight) {
    //       this.pdfScrolledToBottom = true;
    //     }
    //   }

    // @HostListener('scroll', ['$event'])
    pdfScrolled(event: any) {
        // event.target points to the div element
        const element = event.target;
        const atBottom = element.scrollHeight - element.scrollTop <= (element.clientHeight + 10);

        console.log(element.scrollHeight - element.scrollTop);
        console.log(element.clientHeight + 10);

        if (atBottom) {
            console.log('Scrolled to the bottom of the PDF');
            this.pdfScrolledToBottom = true;
        }
    }

    // 10/14/2025 RA
    @HostListener('window:resize', ['$event'])
    onResize() {
        this._adjustPdfZoom();
    }

    private _adjustPdfZoom() {
        const pdfContainer = document.querySelector<HTMLDivElement>('.pdf-viewer');
        if (pdfContainer) {
            const containerWidth = pdfContainer.clientWidth;

            // Adjust zoom based on container width
            if (containerWidth < 600) {
                this.zoom = "0.85"; // Smaller zoom for narrow containers
            } else if (containerWidth < 900) {
                this.zoom = "1"; // Default zoom
            } else {
                this.zoom = "1.00"; // Larger zoom for wide containers
            }
        }
    }

    private _getPdfHeight() {
        const pdfDocumentViewerDialogElement = document.getElementsByClassName('mat-dialog-container');
        if (pdfDocumentViewerDialogElement.length > 0) {
            const pdfHeight: number =
                pdfDocumentViewerDialogElement[0].clientHeight -
                (this.isDeviceOsIos ? this._deviceSettings.iosHeightOffset : this._deviceSettings.mobileHeightOffset);
            this.pdfHeight = pdfHeight.toString() + 'px';
        }
    }
}
